/**
 * GraphQL Query
 * 販売売上レポート画面
 */

/**
 * 期間分析 (フィジカル)
 */
export const GRAPH_QL_QUERY_SALES_PHYSICAL =
`
salesLists ( ?, orderProductCategory:[0,2] ) {
`
/**
 * 期間分析 (デジタル)
 */
export const GRAPH_QL_QUERY_SALES_DIGITAL =
`
salesLists ( ?, orderProductCategory:[1] ) {
`
/**
 * 期間分析(商品別) (フィジカル)
 */
export const GRAPH_QL_QUERY_SALES_PRODUCT_PHYSICAL =
`
salesProductLists ( ?, productCategory:[0] ) {
`
/**
 * 期間分析(商品別) (デジタル)
 */
export const GRAPH_QL_QUERY_SALES_PRODUCT_DIGITAL =
`
salesProductLists ( ?, productCategory:[1] ) {
`
/**
 * 期間分析(エール別) (デジタル)
 */
export const GRAPH_QL_QUERY_SALES_YELL =
`
salesYellLists ( ?, productCategory:[1] ) {
`

/**
 * 期間分析（レスポンス）
 */
export const GRAPH_QL_QUERY_SALES_LIST =
`
  edges {
    node {
      Site
      Month
      Day
      Hour
      PaymentMethod
      cnt_sumSales
      cnt_sumReturn
      salesNet_product
      salesNet_shipping
      salesNet_settlementTax
      salesNet_etc
      salesNet_point
      salesNet_commission
      salesNet_sum
      salesGross_product
      salesGross_shipping
      salesGross_settlementTax
      salesGross_etc
      salesGross_point
      salesGross_commission
      salesGross_sum
      salesTax_product
      salesTax_shipping
      salesTax_settlementTax
      salesTax_etc
      salesTax_point
      salesTax_commission
      salesTax_sum
      returnNet_product
      returnNet_shipping
      returnNet_settlementTax
      returnNet_etc
      returnNet_point
      returnNet_commission
      returnNet_sum
      returnGross_product
      returnGross_shipping
      returnGross_settlementTax
      returnGross_etc
      returnGross_point
      returnGross_commission
      returnGross_sum
      returnTax_product
      returnTax_shipping
      returnTax_settlementTax
      returnTax_etc
      returnTax_point
      returnTax_commission
      returnTax_sum
    }
  }
`

/**
 * 期間分析(商品別)（レスポンス）
 */
export const GRAPH_QL_QUERY_SALES_PRODUCT_LIST =
`
  edges {
    node {
      Site
      Month
      Day
      Hour
      PaymentMethod
      skuCode
      skuName
      janCode
      productCode
      productName
      variationName
      artistCode
      artistName
      unitPriceNet
      unitPriceGross
      orderCnt
      quantity
      amountNet
      amountGross
      returnCnt
      returnQty
      returnAmountNet
      returnAmountGross
      availableQuantity
      productUuid
    }
  }
`
/**
 * 期間分析(エール別)（レスポンス）
 */
export const GRAPH_QL_QUERY_SALES_YELL_LIST =
`
  edges {
    node {
      Site
      Month
      Day
      Hour
      PaymentMethod
      productCode
      productName
      variationName
      artistCode
      artistName
      orderCnt
      quantity
      amountNet
      amountGross
      productUuid
    }
  }
`
